import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const ProgressBar = ({ cartItemsCount = 0 }) => {
  const location = useLocation();
  const [activeSteps, setActiveSteps] = useState({
    step1: false,
    step2: false,
    step3: false
  });

  useEffect(() => {
    // Determine active steps based on current route
    const path = location.pathname;
    
    if (path.includes('/cart')) {
      setActiveSteps({
        step1: cartItemsCount > 0,
        step2: cartItemsCount > 0,
        step3: false
      });
    } else if (path.includes('/checkout')) {
      setActiveSteps({
        step1: true,
        step2: true,
        step3: false
      });
    } else {
      // Default to shop page
      setActiveSteps({
        step1: true,
        step2: false,
        step3: false
      });
    }
  }, [location, cartItemsCount]);

  return (
    <div className="my-8 mx-auto w-[90%] max-w-[800px]">
      <ul className="flex justify-between list-none p-0 m-0">
        {/* Step 1 - Shop Now */}
        <li className={`relative text-center w-full ${activeSteps.step1 ? 'text-green-600 font-bold' : 'text-gray-400'}`}>
          <div className={`w-8 h-8 mx-auto mb-2.5 rounded-full border-2 flex items-center justify-center 
            ${activeSteps.step1 ? 'bg-green-500 border-green-500 text-white' : 'bg-white border-gray-300'}`}>
            {activeSteps.step1 ? '✓' : '1'}
          </div>
          <span className="label">Shop Now</span>
          <div className={`absolute w-full h-0.5 top-4 left-1/2 -z-10 ${activeSteps.step1 ? 'bg-green-500' : 'bg-gray-300'}`}></div>
        </li>

        {/* Step 2 - Cart */}
        <li className={`relative text-center w-full ${activeSteps.step2 ? 'text-green-600 font-bold' : 'text-gray-400'}`}>
          <div className={`w-8 h-8 mx-auto mb-2.5 rounded-full border-2 flex items-center justify-center 
            ${activeSteps.step2 ? 'bg-green-500 border-green-500 text-white' : 'bg-white border-gray-300'}`}>
            {activeSteps.step2 ? '✓' : '2'}
          </div>
          <span className="label">Cart</span>
          <div className={`absolute w-full h-0.5 top-4 left-1/2 -z-10 ${activeSteps.step2 ? 'bg-green-500' : 'bg-gray-300'}`}></div>
        </li>

        {/* Step 3 - Checkout */}
        <li className={`relative text-center w-full ${activeSteps.step3 ? 'text-green-600 font-bold' : 'text-gray-400'}`}>
          <div className={`w-8 h-8 mx-auto mb-2.5 rounded-full border-2 flex items-center justify-center 
            ${activeSteps.step3 ? 'bg-green-500 border-green-500 text-white' : 'bg-white border-gray-300'}`}>
            {activeSteps.step3 ? '✓' : '3'}
          </div>
          <span className="label">Checkout</span>
        </li>
      </ul>
    </div>
  );
};

export default ProgressBar;